import CameraEdit from './CameraEdit'

export default CameraEdit;